import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from '@/App.jsx';
import '@/index.css';

const rootElement = document.getElementById('root');

const appContent = <App />;

const cleanupStaticSeo = () => {
  const staticSeoBlock = document.getElementById('static-seo-content');
  if (staticSeoBlock) {
    staticSeoBlock.remove();
  }
};

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, appContent);
  cleanupStaticSeo();
} else {
  createRoot(rootElement).render(appContent);
  cleanupStaticSeo();
}
